import script from "./LightMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./LightMenu.vue?vue&type=script&setup=true&lang=js"

import "./LightMenu.vue?vue&type=style&index=0&id=13aa5736&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13aa5736"]])

export default __exports__